import React from 'react';
import { Button } from 'common/src/components';
import { _lang, commonLang } from '@umu/ukit-lang';
import { $document } from '@umu/umu-dom';

import './dialogTips.scss';

interface IDialogTipsProps {
    title: string | JSX.Element;
    submitText?: string;
    isShowCancel?: boolean;
    descList: (string | JSX.Element)[];
    onSubmitClick?: VoidFunction;
}

export const onDialogElementCancel = () => {
    removeElementsByClass('dialog-wrapper', false);
};
export const removeElementsByClass = (className: string, isNotAllowCloseAll: boolean) => {
    const elements = $document.getElementsByClassName(className);
    let count = elements.length;
    while (count > 0) {
        count--;
        if (elements[count]) {
            elements[count].remove();
        }
        if (isNotAllowCloseAll || !!count) {
            break;
        }
    }
};

const DialogTips = (props: IDialogTipsProps) => {
    const { title, descList = [], submitText, isShowCancel, onSubmitClick } = props;
    const renderDescList = () => {
        return descList.map((_, index) => {
            return (
                <div key={`desc-tips-${index}`} className="desc-item">
                    {_}
                </div>
            );
        });
    };
    const onCancelClick = () => {
        onDialogElementCancel();
    };
    const onSubClick = () => {
        onSubmitClick && onSubmitClick();
        onDialogElementCancel();
    };
    return (
        <div className="dialog-tips-zone">
            <div className="dialog-tips-title">{title}</div>
            <div className="dialog-tips-desc">{renderDescList()}</div>
            <div className="dialog-tips-footer">
                {isShowCancel && (
                    <Button className="footer-cancel tips-footer-btn" type="grey" onClick={onCancelClick}>
                        {commonLang('取消')}
                    </Button>
                )}
                <Button
                    className={`footer-submit tips-footer-btn ${!isShowCancel ? 'submit-only' : ''}`}
                    onClick={onSubClick}
                >
                    {submitText || commonLang('确认')}
                </Button>
            </div>
        </div>
    );
};
export { DialogTips };
